import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
    const [phone, setPhone] = useState('');
    const [otpCode, setOtpCode] = useState('');
    const [showOtpSection, setShowOtpSection] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [token, setToken] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = urlParams.get('token');

        if (tokenFromUrl) {
            setToken(tokenFromUrl);
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
    }, []);

    const handlePhoneChange = (e) => {
        const cleaned = e.target.value.replace(/[^0-9]/g, '');
        setPhone(cleaned);
    };

    const handleSendPhone = async(e) => {
        e.preventDefault();

        if (!phone || phone.length < 9) {
            setError('Введите корректный номер телефона');
            return;
        }

        if (!token) {
            setError('Отсутствует токен авторизации');
            return;
        }

        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await fetch(`/sendCode?token=${token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone }),
            });

            const result = await response.json();

            if (response.ok && result.code === 200) {
                setShowOtpSection(true);
                setSuccess('Одноразовый код отправлен на ваш номер!');
            } else {
                setError(result.message || 'Ошибка при отправке кода');
            }
        } catch (error) {
            setError('Произошла ошибка при отправке запроса: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSendOtp = async(e) => {
        e.preventDefault();

        if (!otpCode.trim()) {
            setError('Введите код подтверждения');
            return;
        }

        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await fetch(`/oauthToken?token=${token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    phone,
                    otp_code: otpCode,
                }),
            });

            const result = await response.json();
            console.log('OAuth response:', result);

            if (response.ok && result.code === 200) {
                const callbackUrl = `https://sso.dc.tj/callback?token=${token}&p0=${result.p0}`;
                console.log('Redirecting to:', callbackUrl);
                window.location.href = callbackUrl;
            } else {
                setError(result.message || 'Неверный код подтверждения');
            }
        } catch (error) {
            setError('Произошла ошибка при авторизации: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    if (!isAuthenticated) {
        return React.createElement('div', { className: 'auth-container' },
            React.createElement('div', { className: 'auth-sidebar' },
                React.createElement('div', { className: 'sidebar-content' },
                    React.createElement('h1', null, 'Ошибка авторизации'),
                    React.createElement('p', null, 'Отсутствует токен авторизации. Пожалуйста, перейдите по правильной ссылке.')
                )
            ),
            React.createElement('div', { className: 'auth-main' },
                React.createElement('div', { className: 'auth-form' },
                    React.createElement('div', { className: 'welcome-section' },
                        React.createElement('span', { className: 'emoji' }, '⚠️'),
                        React.createElement('h2', null, 'Токен не найден')
                    ),
                    React.createElement('div', { className: 'error-message' },
                        'Для доступа к системе необходим токен авторизации. Пожалуйста, используйте ссылку, предоставленную системой.'
                    )
                )
            )
        );
    }

    return React.createElement('div', { className: 'auth-container' },
        React.createElement('div', { className: 'auth-sidebar' },
            React.createElement('div', { className: 'sidebar-content' },
                React.createElement('h1', null, 'Подключитесь к нашему сервису быстро и безопасно'),
                React.createElement('p', null, 'Авторизуйтесь через свой аккаунт, сохраняя конфиденциальность и безопасность.')
            )
        ),
        React.createElement('div', { className: 'auth-main' },
            React.createElement('div', { className: 'auth-form' },
                React.createElement('div', { className: 'welcome-section' },
                    React.createElement('span', { className: 'emoji' }, '👋'),
                    React.createElement('h2', null, 'Рады видеть вас!')
                ),
                React.createElement('form', { onSubmit: showOtpSection ? handleSendOtp : handleSendPhone }, !showOtpSection ?
                    React.createElement('div', { className: 'form-group' },
                        React.createElement('label', { className: 'form-label', htmlFor: 'phone' }, 'Номер телефона'),
                        React.createElement('input', {
                            type: 'tel',
                            className: 'form-input',
                            id: 'phone',
                            value: phone,
                            onChange: handlePhoneChange,
                            placeholder: '921234567',
                            maxLength: '9',
                            required: true
                        })
                    ) :
                    React.createElement('div', { className: 'form-group' },
                        React.createElement('label', { className: 'form-label', htmlFor: 'otp_code' }, 'СМС код'),
                        React.createElement('input', {
                            type: 'password',
                            className: 'form-input',
                            id: 'otp_code',
                            value: otpCode,
                            onChange: (e) => setOtpCode(e.target.value),
                            placeholder: 'Введите СМС код',
                            required: true
                        })
                    ),
                    React.createElement('button', {
                            type: 'submit',
                            className: 'btn btn-primary',
                            disabled: loading
                        },
                        loading ?
                        React.createElement('span', { className: 'loading' }) :
                        showOtpSection ? 'Авторизоваться' : 'Получить код'
                    )
                ),
                error && React.createElement('div', { className: 'error-message' }, error),
                success && React.createElement('div', { className: 'success-message' }, success),
                React.createElement('div', { className: 'register-link' },
                    React.createElement('small', null, 'У вас нет аккаунта?'),
                    React.createElement('a', { href: '#', className: 'register-text' }, 'Зарегистрироваться')
                )
            )
        )
    );
}

export default App;